import { Typography } from '@mui/material';
import LegalPage from '../../components/common/LegalPage';

// Content from New Website.docx, "Page Title 'Website Terms of Use Agreement'".
export default function TermsOfUse() {
  return (
    <LegalPage title="Website Terms of Use Agreement">
      <Typography variant="h5">Restrictions on Use of Site Content</Typography>
      <Typography variant="body1">
        The text, data, articles, photographs, images, graphics, and other materials (collectively, the
        &ldquo;Content&rdquo;) available on this website (the &ldquo;Site&rdquo;) are owned by Cherry Creek
        Mortgage, LLC or its content providers and are protected by United States and international copyright laws
        and treaties. The Content is and shall remain the property of Cherry Creek Mortgage, LLC. You may not
        copy, modify, reproduce, republish, transmit, distribute, sell, license, or create derivative works from
        any Content, in whole or in part, without the prior written authorization of Cherry Creek Mortgage, LLC.
        Use of the Content on any other website, including by linking, framing, or in any networked computer
        environment for any purpose, is prohibited without prior written consent.
      </Typography>

      <Typography variant="h5">Trademarks</Typography>
      <Typography variant="body1">
        &ldquo;Cherry Creek Mortgage, LLC,&rdquo; the Cherry Creek logo, applicable domain names, and all related
        names, logos, and service marks (collectively, the &ldquo;Cherry Creek Trademarks&rdquo;) are trademarks or
        service marks of Cherry Creek Mortgage, LLC. Other company, product, or service names and logos used on
        this Site may be trademarks or service marks owned by third parties. Nothing on this Site shall be
        construed as granting, by implication or otherwise, any license or right to use any Cherry Creek
        Trademarks without prior written permission in each instance. Use of Cherry Creek Trademarks as part of
        any hyperlink is prohibited unless expressly approved in advance and in writing.
      </Typography>

      <Typography variant="h5">Copyright Complaints (DMCA Notice)</Typography>
      <Typography variant="body1">
        If you believe, in good faith, that any material on this Site infringes your copyright, you may submit a
        notification pursuant to Title 17, United States Code, Section 512(c)(2) (the Digital Millennium Copyright
        Act). Your notification must include:
      </Typography>
      <Typography variant="body1" component="ul">
        <li>A physical or electronic signature of the person authorized to act on behalf of the copyright owner</li>
        <li>Identification of the copyrighted work claimed to have been infringed</li>
        <li>Identification of the allegedly infringing material and its location on the Site</li>
        <li>
          A statement that you have a good-faith belief that the disputed use is not authorized by the copyright
          owner, its agent, or the law
        </li>
        <li>
          A statement, made under penalty of perjury, that the information provided is accurate and that you are
          authorized to act on behalf of the copyright owner
        </li>
      </Typography>
      <Typography variant="body1">
        <strong>DMCA Agent:</strong> Cherry Creek Mortgage, LLC, Attn: Legal Department / DMCA Agent, John Carson,
        SVP, Chief Legal Officer is the Digital Millennium Copyright Act Agent &ndash; this is the person to be
        notified of any copyright infringement of material posted on the CCM LLC website.
      </Typography>

      <Typography variant="h5">No Warranty</Typography>
      <Typography variant="body1">
        This Site and all Content are provided on an &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis.
        Neither Cherry Creek Mortgage, LLC nor its affiliates, service providers, officers, directors, employees,
        contractors, or agents (collectively, the &ldquo;Cherry Creek Parties&rdquo;) makes any warranties or
        representations regarding the accuracy, completeness, reliability, or usefulness of the Content. To the
        fullest extent permitted by law, all warranties—express or implied—are disclaimed, including warranties of
        merchantability, fitness for a particular purpose, non-infringement, and title. Cherry Creek Mortgage, LLC
        does not warrant that the Site is free of viruses or other harmful components or that errors will be
        corrected.
      </Typography>

      <Typography variant="h5">Limitation of Liability</Typography>
      <Typography variant="body1">
        Under no circumstances shall the Cherry Creek Parties be liable for any direct, indirect, incidental,
        consequential, special, punitive, or exemplary damages arising out of or relating to your use of, or
        inability to use, the Site or Content. This limitation applies to all claims, whether based in contract,
        tort, negligence, strict liability, or otherwise, even if Cherry Creek Mortgage, LLC has been advised of
        the possibility of such damages. Your sole remedy for dissatisfaction with the Site is to discontinue use.
      </Typography>

      <Typography variant="h5">Monitoring of the Site</Typography>
      <Typography variant="body1">
        Cherry Creek Mortgage, LLC has no obligation to monitor the Site but reserves the right to do so at any
        time. We may disclose information as necessary to comply with applicable laws, regulations, legal
        processes, or governmental requests, or to protect the rights, safety, and property of Cherry Creek
        Mortgage, LLC or others.
      </Typography>

      <Typography variant="h5">Submissions to the Site</Typography>
      <Typography variant="body1">
        Any remarks, suggestions, ideas, materials, or other submissions you transmit through the Site
        (&ldquo;Submissions&rdquo;) shall be deemed non-confidential and become the property of Cherry Creek
        Mortgage, LLC. Cherry Creek Mortgage, LLC may use Submissions for any lawful purpose without restriction
        or compensation. Nothing herein limits our obligations under the Privacy Policy.
      </Typography>

      <Typography variant="h5">Indemnification</Typography>
      <Typography variant="body1">
        You agree to indemnify and hold harmless the Cherry Creek Parties from and against any claims, damages,
        losses, costs, or expenses (including attorneys&rsquo; fees) arising out of:
      </Typography>
      <Typography variant="body1" component="ul">
        <li>Your use of the Site</li>
        <li>Content or materials you submit or post</li>
        <li>Your violation of these Terms or applicable law</li>
      </Typography>
      <Typography variant="body1">
        Cherry Creek Mortgage, LLC reserves the right to assume exclusive defense and control of any matter subject
        to indemnification.
      </Typography>

      <Typography variant="h5">Links to Third-Party Sites</Typography>
      <Typography variant="body1">
        The Site may contain links to third-party websites not controlled by Cherry Creek Mortgage, LLC. We are
        not responsible for the content, accuracy, or availability of such sites. Access to third-party websites
        is at your own risk and governed by the terms and policies of those websites. Links do not constitute
        endorsement.
      </Typography>

      <Typography variant="h5">Foreign Accessibility Disclaimer</Typography>
      <Typography variant="body1">
        Cherry Creek Mortgage, LLC makes no representation that the Site or services described are appropriate or
        available for use in all jurisdictions.
      </Typography>

      <Typography variant="h5">Use of Personally Identifiable Information</Typography>
      <Typography variant="body1">
        Our practices regarding the collection and use of personal information are governed by the Cherry Creek
        Mortgage, LLC Privacy Policy, which is incorporated by reference.
      </Typography>

      <Typography variant="h5">User Conduct</Typography>
      <Typography variant="body1">
        You agree to use the Site and Content only for lawful purposes and in compliance with all applicable laws
        and regulations. Unauthorized use may result in termination of access.
      </Typography>

      <Typography variant="h5">Termination</Typography>
      <Typography variant="body1">
        Cherry Creek Mortgage, LLC may suspend or terminate your access to the Site at any time, with or without
        notice or cause. Provisions relating to warranties, limitations of liability, indemnification, governing
        law, and dispute resolution shall survive termination.
      </Typography>

      <Typography variant="h5">General Provisions</Typography>
      <Typography variant="body1">
        These Terms shall be governed by and construed in accordance with the laws of Delaware without regard to
        conflict-of-laws principles. All disputes arising from your use of the Site shall be resolved exclusively
        in the state or federal courts located in Delaware, and you consent to personal jurisdiction in such
        courts. If any provision is found unenforceable, the remaining provisions shall remain in full force and
        effect. Failure to enforce any provision shall not constitute a waiver.
      </Typography>

      <Typography variant="h5">Contact Us</Typography>
      <Typography variant="body1">If you have questions regarding these Terms of Use, please contact:</Typography>
      <Typography variant="body1">
        Cherry Creek Mortgage, LLC, Attn: Legal / Compliance Department, John Carson, SVP, Chief Legal Officer,
        5600 S Quebec, Greenwood Village, CO 80111; john.carson@ccmloanservices.com
      </Typography>
    </LegalPage>
  );
}
